import PopupInformation from "shared/components/popups/PopupInformation.js";

const PopupInformationFormationMeta = ({}) => {
  return (
    <PopupInformation
      trigger={<i class="bi bi-info-circle-fill text-main cursor-pointer ms-1"></i>}
      title={"What is formation meta?"}
      content={
        <div>
          <p>
            <strong>Formation Meta</strong> shows how effective your selected formation is against specific opponent
            formations, based on historical match data.
          </p>

          <p>Each cell displays three percentages:</p>

          <ul>
            <li>
              <span className="text-main">
                <b>First percentage</b>
              </span>
              : Win rate of <strong>your formation</strong> against the opponent formation
            </li>
            <li>
              <strong>Second percentage (if any)</strong>: Draw rate
            </li>
            <li>
              <strong>Third percentage (if any)</strong>: Loss rate
            </li>
          </ul>

          <p>In the bottom-right corner of each cell, the number indicates how many matches this data is based on.</p>

          <hr />

          <p>
            <strong>Data constraints:</strong>
          </p>

          <ul>
            <li>
              Only matches with a maximum of <strong>20 OVR difference</strong> between the two teams are considered
            </li>
            <li>
              For the Match Planner, only matches played using the <strong>current engine version</strong> are included
            </li>
          </ul>

          <p>
            Higher win percentages suggest a stronger matchup for your formation, but results are more reliable when
            based on a larger number of games.
          </p>
        </div>
      }
    />
  );
};

export default PopupInformationFormationMeta;
